import React, {Fragment} from "react";
import DsdsList from "./List";
import {connect} from 'react-redux';
import ReduxDsdDetailModal from "../../../redux-components/redux-dsd-detail-modal"
import {MM_DSDS_PREFIX} from "./reducer";
import ArtefactFullExportForm from "../../../redux-components/redux-artefact-full-export";

const mapStateToProps = state => ({
  dsdDetail: state.scenes.metaManager.dsds.dsdDetail
});

const mapDispatchToProps = dispatch => ({
});

const Dsds = ({
                dsdDetail,
              }) =>
  <Fragment>
    <DsdsList/>
    <ReduxDsdDetailModal
      instancePrefix={MM_DSDS_PREFIX}
      instanceState={dsdDetail}
    />
    <ArtefactFullExportForm/>
  </Fragment>;

export default connect(mapStateToProps, mapDispatchToProps)(Dsds);
